module.exports = __webpack_public_path__ + "img/b315e972163b10ad6b562a3b1e1c6e58.065323cc.jpg";